export default __webpack_public_path__ + "static/media/instaclone.45a1a7a9.png";